import * as React from "react";

import { useState, useEffect } from "react";

import { reduxForm, getFormValues, Field, change } from "redux-form";

import { connect } from "react-redux";

import { Row, Col } from "reactstrap";

import errorEmail from "../../images/errorEmil.svg";

import emailerrorInfo from "../../images/emil-errorInfo.svg";

import { Button } from "reactstrap";

import SpinnerModel from "../../commonfields/SpinnerModel";

import Service from "../../services";


// import validate from "../layout/Leads/NewLead/Validate";

import validate from "./Validate";
import warn from "../layout/Leads/NewLead/FieldErrors";
import EmailTextField from "../../commonfields/EmailTextField";

import { ISignStatusModel } from "../../models/StatusTabModel";

const EditEmailInfoForm: React.FC = (props: any) => {
  const [checkEmail, setEmailCheck] = useState(false);

  const service = new Service();
  const EmailCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    const error =
      value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? false
        : true;

    setEmailCheck(error);
  };        
  return (
    <>
      {props.loader ? (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      ) : (
        ""
      )}
 
      <form
        autoComplete="off"
        className="email-modal "
        onSubmit={(e: any) => props.handleFormSubmit(e, props.formValues)}
      >
      
            <div className="total-comtainer">
              <div className="email-container">
                <Row className="email-box">
              <Col className="existing-name" >
                <Row className="name-text" >Name</Row>
                <Row className="name">{props?.data?.name}</Row>
                </Col>
                <Col className="existing-email">
                <Row className="email-text"><div>Current Email Address&nbsp; 
                  {props.data.status ==='autoresponded'?
                   (<span className="email-error"><img src={emailerrorInfo} alt="errorIcon" />&nbsp;Failed</span>):(<></>)}              
                  
                   </div></Row>                             
                               
                <Row className="email">{props?.data?.email}</Row>                
                </Col>
                </Row>
                </div>

              <div className="contactInfoRow">
              <div>
                  <div>
                    <Field
                      name="newEmail"
                      component={EmailTextField}
                      type="text"
                      label="New Email Address"
                      helpText="Email"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        EmailCheck(e)                                         
                      }
                    />
                  </div>  
                  {
                  props?.editEmailError?.error?
                  <div className="duplicate-error"><img src={errorEmail} alt="errorIcon" />&nbsp;Email already used</div> :(<></>)
                  
                  }               
                  
                </div>
                
              </div>
             
           
            </div>
        

          <div className="contact-save">
            <div>
            <Button
              className="save-button"
              disabled={props.invalid}
              type="submit"
            >
                 Resend
                </Button>
               </div>
        
              <div
              className="cancel-button"       
              onClick = {props?.toggleHandle}
            >
            Cancel
            
            </div>
     
          </div>
        
                 
      
      </form>
    </>
  );
};

const mapStateToProps = (state: any, props: any) => ({
  initialValues: props.data, // retrieve name from redux store

  formValues: getFormValues("EditEmailInfoForm")(state),
});

export default connect(mapStateToProps)(
  reduxForm<Record<string, unknown>, any>({
    form: "EditEmailInfoForm",

    enableReinitialize: true,

    validate,

    warn,
  })(EditEmailInfoForm)
);
